import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

export interface MobileNavConfirmProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export function MobileNavConfirm({ open, onCancel, onConfirm }: MobileNavConfirmProps) {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>Leave without saving?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          You have unsaved changes that will be lost.
        </DialogContentText>
        <div style={{ display: "flex", gap: 8, marginTop: 20 }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1,
              padding: "10px 0",
              fontSize: 14,
              fontWeight: 500,
              cursor: "pointer",
              background: "transparent",
              color: "#0a2540",
              border: "2px solid #0a2540",
              borderRadius: 6,
            }}
          >
            Stay
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1,
              padding: "10px 0",
              fontSize: 14,
              fontWeight: 500,
              cursor: "pointer",
              background: "#d32f2f",
              color: "#ffffff",
              border: "none",
              borderRadius: 6,
            }}
          >
            Leave
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}